import { resolvePotentiallyExternalLabel, type TransformationContext } from "./translationUtils";

import { type TranslationModel, TranslationType } from "~/common/TranslationModel";

export const CONFIGURATOR_NAME_KEY = "CONFIGURATOR_NAME";
export const getStepNameKey = (stepNo: number) => {
  return `STEP_${stepNo}_NAME`;
};
export const RESET_SELECTION = "RESET_SELECTION";
export const RESET_STANDARD = "RESET_STANDARD";
export const RESET_SELECTION_AND_LENGTH = "RESET_SELECTION_AND_LENGTH";
export const CONTACT_STC_ADD_DESCRIPTION = "CONTACT_STC_ADD_DESCRIPTION";
export const AL_AND_AR_ADD_DESCRIPTION = "AL_AND_AR_ADD_DESCRIPTION";
export const ALAR_NOT_RECOMMENDED_WARNING = "ALAR_NOT_RECOMMENDED_WARNING";
export const ALAR_RECOMMENDED_LABEL = "ALAR_RECOMMENDED_LABEL";

export const resolveExternalAdvancedTranslation = (
  translations: Dict<TranslationModel>,
  context: TransformationContext,
  key: string,
) => {
  const data = context.specialTranslations[key];
  if (data) {
    translations[key] = {
      type: TranslationType.EXTERNAL,
      value: resolvePotentiallyExternalLabel(data.name, context),
    };
  } else {
    translations[key] = {
      type: TranslationType.RAW_TEXT,
      value: "",
    };
  }
};

export const resolveInternalAdvancedTranslation = (
  translations: Dict<TranslationModel>,
  key: string,
  i18nKey: string,
) => {
  translations[key] = {
    type: TranslationType.INTERNAL,
    value: i18nKey,
    params: {},
  };
};

export const resolveRawAdvancedTranslation = (translations: Dict<TranslationModel>, key: string, value: string) => {
  translations[key] = {
    type: TranslationType.RAW_TEXT,
    value: value,
  };
};
